import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  effect,
  inject,
} from '@angular/core';
import { PermissionValidatorService } from '@nomoh-monorepo/data-access-auth';

@Directive({
  selector: '[libHasPermission]',
  standalone: true,
})
export class HasPermissionDirective {
  private permissionService = inject(PermissionValidatorService);
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);

  @Input() set hasPermission(permissionKey: string) {
    // Effect: Re-renderizar quando permissões mudarem
    effect(() => {
      const hasPermission = this.permissionService.hasPermission(permissionKey);

      if (hasPermission) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
